import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  FieldMetaData,
  PersonStammMasterDetailEntryMeta,
  PersonstammpersonService,
  ZentralePersonDetailEntryMeta
} from 'app/core/personstamm-api';
import { NavTarget } from 'app/shared/components/link/link.component';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktPersonenadresseComponent } from '../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { KompaktStammpersonComponent } from '../../../shared/kompaktdarstellung/stammperson/kompakt-stammperson.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { PersonstammEigentumComponent } from '../../person-stamm/detail/eigentum/personstamm-eigentum.component';
import { PersonstammUebrigeBerechtigungenComponent } from '../../person-stamm/detail/uebrige-berechtigungen/personstamm-uebrige-berechtigungen.component';
import { NeskoabGrundstueckeZpvpersonenComponent } from '../../../neskoab/neskoab-grundstuecke-zpvpersonen/neskoab-grundstuecke-zpvpersonen.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { FormatAhvPipe } from '../../../shared/pipes/format/format-ahv.pipe';
import { TooltipPersonstammPipe } from '../../../shared/pipes/simple/tooltip-personstamm.pipe';
import { TranslateNamePipe } from '../../../shared/pipes/simple/translate-name.pipe';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../core/base-api';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-zpv-detail',
  templateUrl: './zpv-detail.component.html',
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    KopfdatenelementComponent,
    KompaktPersonenadresseComponent,
    LinkComponent,
    KompaktStammpersonComponent,
    RubrikComponent,
    PersonstammEigentumComponent,
    PersonstammUebrigeBerechtigungenComponent,
    NeskoabGrundstueckeZpvpersonenComponent,
    NgbTooltip,
    TranslatePipe,
    DatumPipe,
    FormatAhvPipe,
    TooltipPersonstammPipe,
    TranslateNamePipe
  ]
})
export class ZpvDetailComponent extends AbstractComponent implements OnInit {
  navTargets = NavTarget;

  entry: ZentralePersonDetailEntryMeta;
  stammPersonMaster: PersonStammMasterDetailEntryMeta;
  stammPersonLoaded = false;

  AccessEnum = FieldMetaData.AccessEnum;

  constructor(
    private route: ActivatedRoute,
    private personService: PersonstammpersonService,
    private permissionService: AppPermissionService
  ) {
    super();
    keysToTranslate<string>([
      'Name/Bezeichnung1',
      'Vorname/Bezeichnung2',
      'ZPVNummer',
      'StammpersonImGrundbuch',
      'gemaessZPV',
      'titel.zentralePerson',
      'uebrigeBerechtigungenImGrundbuch',
      'eigentumImGrundbuch',
      'eintragungAmtlicheBewertung',
      'Gesamteigentum',
      'Alleineigentum'
    ]);
  }

  ngOnInit() {
    this.addSub(
      this.route.data.subscribe((data) => {
        this.entry = data.entity;
        this.personService.loadByFremdId(this.entry.fremdId, this.entry.fremdsystemId).subscribe((stammPersonMaster) => {
          this.stammPersonLoaded = true;
          this.stammPersonMaster = stammPersonMaster;
        });
      })
    );
  }

  hasAuskunftsperre(): boolean {
    return (
      this.stammPersonMaster &&
      this.stammPersonMaster.auskunftsperre &&
      this.stammPersonMaster.auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE &&
      this.permissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE)
    );
  }
}
